import { render, staticRenderFns } from "./document-color.vue?vue&type=template&id=cc711628&"
import script from "./document-color.vue?vue&type=script&lang=js&"
export * from "./document-color.vue?vue&type=script&lang=js&"
import style0 from "./document-color.vue?vue&type=style&index=0&id=cc711628&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc711628')) {
      api.createRecord('cc711628', component.options)
    } else {
      api.reload('cc711628', component.options)
    }
    module.hot.accept("./document-color.vue?vue&type=template&id=cc711628&", function () {
      api.rerender('cc711628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/document-color.vue"
export default component.exports